import React, { Component } from 'react'


class ReservationsDisplay extends Component {

    constructor(props){
        super(props)
        this.generatePDF = this.generatePDF.bind(this)
    }

    generatePDF(){
        
    }

    render(){
        const {reservations} = this.props
        const {generatePDF} = this
        return(
            <div>
                <input type="button" onClick={generatePDF} value="Exportar a PDF" className="button-add-reserve"/>
                <table className="display-reservations-table">
                    <tr className="display-reservations-table-tr">
                        <th className="display-reservations-table-th"> Reserva </th>
                        <th className="display-reservations-table-th"> Nombre </th>
                        <th className="display-reservations-table-th"> Telefono </th>
                        <th className="display-reservations-table-th"> Invitados </th>
                    </tr>
                    {
                        Object.keys(reservations).map(item => {
                            return (
                                <tr className="display-reservations-table-tr">
                                    <td className="display-reservations-table-td"> {item} </td>
                                    <td className="display-reservations-table-td"> {reservations[item].name} </td>
                                    <td className="display-reservations-table-td"> {reservations[item].phone} </td>
                                    <td className="display-reservations-table-td">
                                        {reservations[item].guests.replaceAll(",", "\n")}
                                    </td>
                                </tr>
                            )
                        })
                    }
                </table>
            </div>
        )
    }
}

export default ReservationsDisplay